<template>
  <div :class="['work-duration-input row no-wrap']">
    <!-- 小时 -->
    <q-input type="number" v-model="hourStr" input-class="time-input text-right" maxlength="2" style="width: 50px"
      @focus="selectAll($event)" @update:model-value="onHourChange" hide-bottom-space borderless :dense="dense" />
    <span class="unit">{{ t('hour2') }}</span>

    <!-- 分钟 -->
    <q-input type="number" v-model="minuteStr" input-class="time-input text-right" maxlength="2" style="width: 60px"
      @focus="selectAll($event)" @update:model-value="onMinuteChange" hide-bottom-space borderless :dense="dense" />
    <span class="unit">{{ t('minute2') }}</span>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  modelValue: Number,
  dense: Boolean
})

const emit = defineEmits(['update:modelValue'])

const hourStr = ref('')
const minuteStr = ref('')

// 同步父组件 value
watch(
  () => props.modelValue,
  (val) => {
    const total = Math.max(parseInt(val || 0), 0)
    hourStr.value = Math.floor(total / 60).toString()
    minuteStr.value = (total % 60).toString()
  },
  { immediate: true }
)

function emitValue(hour, minute) {
  const total = Math.max(hour * 60 + minute, 0)
  emit('update:modelValue', total)
}

// 小时输入
function onHourChange(val) {
  if (!val) val = '0'
  if (val.length > 2) val = val.slice(0, 2)
  let hour = parseInt(val || 0)
  if (hour < 0) hour = 0
  const minute = parseInt(minuteStr.value || 0)
  emitValue(hour, minute)
}

// 分钟输入（限制在 0~59 范围内）
function onMinuteChange(val) {
  if (!val) val = '0'
  if (val.length > 2) val = val.slice(0, 2)
  let minute = parseInt(val || 0)
  if (isNaN(minute) || minute < 0) minute = 0
  if (minute > 59) minute = 59
  minuteStr.value = minute.toString()
  const hour = parseInt(hourStr.value || 0)
  emitValue(hour, minute)
}

// 自动选中全部内容
function selectAll(e) {
  e.target.select()
}
</script>

<style scoped>
.work-duration-input {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ccc;
  /* 下划线 */
  padding-bottom: 2px;
  width: max-content;
}

.unit {
  margin-right: 6px;
  font-size: 14px;
}

.time-input {
  border: none;
  outline: none;
  background: transparent;
  padding: 2px 0;
}

.time-input:focus {
  border-bottom: none;
}
</style>
